import AudioCaptions from './AudioCaptions';

export default AudioCaptions;
